import React, {Component} from 'react';
import woothee from "woothee";
import reactMixin from 'react-mixin';
import Entity from './mixins/adArea';

class AdArea extends Component {
    constructor(props) {
        super(props)
        this.state = {
            displayPcAd: false, displayMobileAd: false, os: ""
        };
    }

    componentDidMount() {
        const parser = woothee.parse(navigator.userAgent);
        if (parser.category === 'pc') {
            this.displayPcAdAreaAction(true);
        } else {
            this.displayMobileAdAreaAction(true);
        }
        this.setOsAction(parser.os);
    }

    render() {
        return (
            <section>
                <div id="pc_ad_area" style={{display: this.state.displayPcAd ? 'block' : 'none'}}>
                    <a href="https://ggm-contents.bangumi.org/moveMarket/index.html?from=gorin" id="pc_ad_img">
                        <img src={require('../images/pc_ad_img.jpg')} alt={''}/>
                    </a>
                    <a href="" id="pc_ad_close" onClick={e => this.displayPcAdArea(e, false)}>
                        <img src={require('../images/pc_ad_close.png')} alt={""}/>
                    </a>
                </div>
                <div id="mobile_ad_area" style={{display: this.state.displayMobileAd ? 'block' : 'none'}}>
                    <a href="https://ggm-contents.bangumi.org/moveMarket/index.html?from=gorin" id="mobile_ad_img">
                        <img src={require('../images/mobile_ad_img.png')} alt={''}/>
                    </a>
                </div>
            </section>
        );
    }
}

reactMixin.onClass(AdArea, Entity);

export default AdArea;


// WEBPACK FOOTER //
// ./src/components/adArea.js